/* This code was auto-generated **DO NOT EDIT**
 * If you need to make changes to this file please refer to README.md
 */

import React, { forwardRef } from "react";
import { oneOf, string } from "prop-types";

import componentSizes from "../../constants/componentSizes";
import DownsideLG from "../assets/brand/LG/downside.svg";
import DownsideMD from "../assets/brand/MD/downside.svg";
import DownsideSM from "../assets/brand/SM/downside.svg";
import * as S from "../styled";

const DownsideIconAssets = {
  [componentSizes.LG]: DownsideLG,
  [componentSizes.MD]: DownsideMD,
  [componentSizes.SM]: DownsideSM
};

const DownsideIcon = forwardRef(
  ({ className, size, ...passThroughProps }, ref) => (
    <S.Icon
      ref={ref}
      className={className}
      src={DownsideIconAssets[size]}
      {...passThroughProps}
    />
  )
);

DownsideIcon.propTypes = {
  className: string,
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG])
};

DownsideIcon.defaultProps = {
  className: "",
  size: componentSizes.MD
};

export default DownsideIcon;
